<template>
  <div>
    <q-autocomplete
      :disabled="disabled"
      v-model="inputValue"
      :class="{ 'hide-search': !isFocused }"
      :items="countriesSorted"
      :filled="filled"
      :dense="dense"
      :outlined="outlined"
      item-text="name"
      item-value="iso2"
      :label="!labelAbove && !hideLabel ? 'Country Code' : ''"
      autocomplete="nope"
      :error="error"
      :hint="hint"
      :persistent-hint="persistentHint"
      :filter="countryFilter"
      :hide-details="hideDetails"
      @mousedown="isFocused = true"
      @blur="isFocused = false"
    >
      <template v-slot:selection="{ item }">
        <div v-if="!isFocused">
          <div
            :class="
              `d-inline-block iti-flag-small iti-flag ${item.iso2.toLowerCase()}`
            "
          />
          + {{ item.dialCode }}
        </div>
      </template>
      <template v-slot:item="{ item }">
        <div class="d-flex flex-row align-center">
          <div
            :class="`iti-flag-small iti-flag mr-2 ${item.iso2.toLowerCase()}`"
          />
          <div style="line-height: 1">
            {{ item.name }}
            <small>{{ '+' + item.dialCode }}</small>
          </div>
        </div>
      </template>
    </q-autocomplete>
  </div>
</template>

<script>
import { getCountryCallingCode } from 'libphonenumber-js';

export default {
  name: 'CountrySelector',
  props: {
    countryCode: { type: String },
    label: { type: String, default: 'Choose country' },
    hint: { type: String, default: '' },
    error: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    valid: { type: Boolean, default: false },
    items: { type: Array, default: Array, required: true },
    preferredCountries: { type: Array, default: null },
    onlyCountries: { type: Array, default: null },
    ignoredCountries: { type: Array, default: null },
    noFlags: { type: Boolean, default: false },
    showCodeOnList: { type: Boolean, default: false },
    filled: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    labelAbove: { type: Boolean, default: false },
    persistentHint: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    hideLabel: { type: Boolean, default: false },
  },
  data: () => ({
    isFocused: false,
  }),
  computed: {
    inputValue: {
      get() {
        return this.countriesSorted.find(
          (item) => item.iso2 === this.countryCode
        );
      },
      set(v) {
        this.$emit('update:country-code', v);
      },
    },
    countriesList() {
      return this.items.filter(
        (item) => !this.ignoredCountries.includes(item.iso2)
      );
    },
    countriesFiltered() {
      const countries = this.onlyCountries || this.preferredCountries;
      return countries.map((country) =>
        this.countriesList.find((item) => item.iso2.includes(country))
      );
    },
    otherCountries() {
      return this.countriesList.filter(
        (item) => !this.preferredCountries.includes(item.iso2)
      );
    },
    countriesSorted() {
      return this.preferredCountries
        ? [...this.countriesFiltered, ...this.otherCountries]
        : this.onlyCountries
        ? this.countriesFiltered
        : this.countriesList;
    },
    callingCode() {
      return this.countryCode
        ? `+${getCountryCallingCode(this.countryCode)}`
        : null;
    },
  },
  watch: {
    inputValue(v) {
      console.debug(v);
    },
  },
  methods: {
    countryFilter(item, queryText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.dialCode.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import './assets/iti-flags/flags.css';

.hide-search::v-deep .v-select__selections input {
  display: none;
}

.v-autocomplete::v-deep .v-select__slot {
  padding: 2px 0;
}

.v-text-field--filled {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
